import useSWRMutationForm, { useErrorToSnackbar } from 'common-form/useSWRMutationForm';
import usePrequalUpdate from '../../resources/prequal/usePrequalUpdate';

const useForm = () => useSWRMutationForm({
  useMutation: usePrequalUpdate,
  useUnhandledError: useErrorToSnackbar,
});

export default useForm;
